import { createContext, useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Device, DeviceType } from '../utils/helpers/getDeviceType';

export interface PageProps {
  deviceType?: DeviceType;
  device?: Device;
  mainPageImage?: string | null;
}

export const PageContext = createContext<PageProps>({
  deviceType: DeviceType.desktop,
  device: { model: null, vendor: null },
  mainPageImage: null
});

export const usePageProps = () => useContext(PageContext);
